import Row from '@totallymoney/ui/components/Row'
import Text from '@totallymoney/ui/components/Text'
import theme from '@totallymoney/ui/theme'

import TooltipButton from '@components/TooltipButton'

interface LoanCategoryTooltipProps {
    loanCategory: string
    loanId: string
    onShowLoanCategoryModal: () => void
}

const tooltipColor = theme.grey80

const LoanCategoryTooltip = ({
    loanCategory,
    loanId,
    onShowLoanCategoryModal,
}: LoanCategoryTooltipProps) => (
    <Row space={['space05', 'space10']} alignItems="center" flexShrink={[1, 0]}>
        <Text
            variant="80"
            weight="bold"
            style={{
                color: tooltipColor,
            }}
        >
            {loanCategory}
        </Text>

        <TooltipButton
            aria-label={`What is a ${loanCategory}?`}
            data-testid={`${loanCategory}-${loanId}`}
            title={`About ${loanCategory}`}
            size={20}
            color={tooltipColor}
            onPress={onShowLoanCategoryModal}
        />
    </Row>
)

export default LoanCategoryTooltip
